/**
 * customers-api — RETAINED FOR ITS REMAINING CONSUMER (2026-09-10 drop).
 *
 * Every directory/detail/settings read and write now lives in
 * `customers-data.ts`, against the operations the drop declares binding. What
 * is left here is the one op an unrelated screen still calls:
 * `customerItemAction`, from `screens/reports/ReportsCampusPulse.tsx`. The
 * retired REQ-069 wrappers (listCustomers, messageCustomer,
 * bookCustomerAppointment, registerCustomerForEvent) went with the prototype
 * screen — the Customers surface has no message, book or register action.
 */
import { apiRaw } from "@v0y4ge/api-client";
import { reportOpSource } from "../../shell/opSource";

const tag = <T,>(op: string, p: Promise<T>): Promise<T> =>
  p.then((r) => { reportOpSource(op, r); return r; });
const json = (body: unknown): RequestInit => ({ method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(body) });

/** Contextual activity action recorded against a customer. */
export interface ItemActionInput { kind: string; action: string; ref?: string | null; }
export const customerItemAction = (id: string, input: ItemActionInput) =>
  tag("customerItemAction", apiRaw<{ ok: boolean }>(`/v1/admin/customers/${encodeURIComponent(id)}/activity`, json(input), 'customerItemAction'));
